import { factory } from '@store/utils'

export default {
  auto: '*',

  store: {
    getters: {
      pageBatchFactory: factory(() => ({
        isPaused: false,
        pageCount: null,
        urls: null,
      })),
    },
  },
}
